export const FETCH_EXCHANGE_RATES = 'fetch_exchange_rates',
  FETCH_EXCHANGE_RATES_SUCCESS = 'fetch_exchange_rates_success',
  FETCH_EXCHANGE_RATES_FAIL = 'fetch_exchange_rates_fail';
